:host {
  .flex {
    display: flex;
  }

  .align-items--center {
    align-items: center;
  }

  .documentation-description {
    color: #333;
    color: var(--font-primary);
  }

  .documentation-link {
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
    border: 1px solid #5e6981;
    border-radius: 10px;
    padding: 20px;
    margin: 20px 0;
    width: 100%;
    text-decoration: none;

    &__logo {
      max-width: 130px;
    }

    &__text {
      color: #333;
      color: var(--font-primary);
      margin-right: 20px;
    }

    &__arrow {
      filter: invert(54%) sepia(44%) saturate(7155%) hue-rotate(183deg) brightness(102%)
        contrast(109%);
      filter: var(--icon-blue);
    }

    &:focus {
      outline: none;
    }
  }
}
